import styled, {css} from 'styled-components';

import {Button} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const ToggleButtons = styled.div`
  ${mixins.flexAlign('flex-start', 'center')}
  width: max-content;
  border-radius: ${({theme}) => theme.borderRadius.br2};
`;

type TToggleButtonProps = {
  active: boolean;
};

export const ToggleButton = styled(Button)<TToggleButtonProps>`
  ${mixins.flexAlign('center')}
  position: relative;
  border-radius: 0;
  ${({theme, active}) => css`
    cursor: ${active ? 'default' : 'pointer'};
    &:not(:last-child) {
      border-right: none;
    }
    &:first-child {
      border-top-left-radius: ${theme.borderRadius.br2};
      border-bottom-left-radius: ${theme.borderRadius.br2};
    }
    &:last-child {
      border-top-right-radius: ${theme.borderRadius.br2};
      border-bottom-right-radius: ${theme.borderRadius.br2};
    }
  `}
`;

export const TertiaryToggleButton = styled(ToggleButton)`
  background: ${({theme, active}) => (active ? theme.palette.grey50 : theme.palette.white)};
  border-color: ${({theme, active}) => (active ? theme.palette.grey50 : theme.palette.white)};
`;
